import { render, staticRenderFns } from "./NavbarLogotipo.vue?vue&type=template&id=dfa64bc2&"
import script from "./NavbarLogotipo.vue?vue&type=script&lang=js&"
export * from "./NavbarLogotipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports